// Clip status type definitions
// Only applies to comp clips and stock footage

export const CLIP_STATUS_TYPES = {
  vfx_comp: {
    label: 'VFX Comp',
    statuses: ['Pending Review', 'Approved', 'Needs Revision', 'Rejected'] as const
  },
  stock_footage: {
    label: 'Stock Footage',
    statuses: ['Sourced', 'Licensed', 'Available', 'Used'] as const
  }
} as const;

export type ClipStatusType = keyof typeof CLIP_STATUS_TYPES;
export type ClipStatus = typeof CLIP_STATUS_TYPES[ClipStatusType]['statuses'][number];

// Helper to get available statuses for a given type
export function getStatusesForType(type: ClipStatusType): readonly string[] {
  return CLIP_STATUS_TYPES[type].statuses;
}

// Helper to get status label for display
export function getStatusTypeLabel(type: ClipStatusType): string {
  return CLIP_STATUS_TYPES[type].label;
}

// Helper to validate status for a given type
export function isValidStatus(status: string, type: ClipStatusType): boolean {
  const statuses = CLIP_STATUS_TYPES[type].statuses as readonly string[];
  return statuses.includes(status);
}

// Color mapping for status badges
export function getStatusColor(status: string, type: ClipStatusType): string {
  if (type === 'vfx_comp') {
    switch (status) {
      case 'Approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'Pending Review':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Needs Revision':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'Rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  }

  if (type === 'stock_footage') {
    switch (status) {
      case 'Licensed':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'Available':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'Sourced':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'Used':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  }

  return 'bg-gray-100 text-gray-800 border-gray-200';
}
